module.exports = __webpack_public_path__ + "img/cattolica-milano.6a7605ef.jpg";